import React from 'react';
import TablePagination from '@mui/material/TablePagination';

/**
 * Server-side pagination footer.
 *
 * Two modes:
 * - When `total` is a number, shows real counts ("11–20 of 57") and allows
 *   jumping to the last page. Use this wherever the API returns a total.
 * - Otherwise falls back to prev/next only, driven by `hasMore` — for
 *   endpoints that do not report a count.
 *
 * Props:
 * - page: zero-based page index shown in the UI
 * - size: current page size
 * - total: optional total row count from the API
 * - hasMore: whether a next page may exist (usually items.length === size).
 *   Ignored when `total` is supplied.
 * - onChange(page, size): called with the new zero-based page and size
 */
export default function TablePaginationInc(props) {
  var hasTotal = typeof props.total === 'number' && props.total >= 0;

  function handlePageChange(event, newPage) {
    props.onChange(newPage, props.size);
  }

  function handleSizeChange(event) {
    props.onChange(0, Number(event.target.value));
  }

  function labelDisplayedRows() {
    return 'Page ' + (props.page + 1);
  }

  var countOnlyProps = {};
  if (!hasTotal) {
    countOnlyProps.nextIconButtonProps = { disabled: !props.hasMore };
    countOnlyProps.labelDisplayedRows = labelDisplayedRows;
  }

  return (
    <TablePagination
      component="div"
      count={hasTotal ? props.total : -1}
      rowsPerPageOptions={[10, 25, 50, 100]}
      rowsPerPage={props.size}
      page={props.page}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleSizeChange}
      {...countOnlyProps}
    />
  );
}
